/**
 * Vehicle Electrification slider semantics (Policy Tool):
 * - Slider 0–100 = progress from EMFAC BAU 2045 EV share → 100% ZEV by 2045
 * - 0% = BAU (no incremental local ZEV beyond the EMFAC pathway)
 * - 100% = 100% light-duty ZEV in 2045
 *
 * Model/scenario still uses absolute fleet EV% in 2045 (`evAdoptionPercent`).
 */

/** Map UI slider (beyond-BAU) → absolute 2045 EV fleet %. */
export function beyondBauEvSliderToAbsolute(slider0to100: number, bau2045Percent: number): number {
  const bau = Math.max(0, Math.min(100, Number(bau2045Percent) || 0));
  const s = Math.max(0, Math.min(100, Number(slider0to100) || 0));
  return bau + ((100 - bau) * s) / 100;
}

/** Map absolute 2045 EV% → UI slider (beyond-BAU). Values below BAU clamp to 0. */
export function absoluteEvToBeyondBauSlider(absolute2045Percent: number, bau2045Percent: number): number {
  const bau = Math.max(0, Math.min(100, Number(bau2045Percent) || 0));
  const abs = Math.max(0, Math.min(100, Number(absolute2045Percent) || 0));
  const span = 100 - bau;
  if (span < 1e-6) return abs >= 100 ? 100 : 0;
  return Math.max(0, Math.min(100, ((abs - bau) / span) * 100));
}
